export default __webpack_public_path__ + "static/media/OfficeBlack.2f014e9b.png";